import { MapToContext } from '@utils/objectWithDefault'

export class Network {
  constructor (networkData) {
    const defaultNetwork = {
      name: { val: 'ShipBob Network', type: String },
      id: { val: 0, type: Number },
      isoCode: { val: '', type: String }
    }

    MapToContext(this, defaultNetwork, networkData)
  }
}

export default class Networks {
  constructor (networksData) {
    const defaultNetworks = {
      networks: { val: [], type: Array, subType: Network }
    }

    MapToContext(this, defaultNetworks, networksData)
  }

  getNetworks () {
    return this.networks
  }
}
